import { forwardRef } from 'react'
import { Breadcrumbs as MuiBreadcrumbs, type BreadcrumbsProps as MuiBreadcrumbsProps } from '@mui/material'

export type BreadcrumbsProps = MuiBreadcrumbsProps

export const Breadcrumbs = forwardRef<HTMLElement, BreadcrumbsProps>(function Breadcrumbs(props, ref) {
  return <MuiBreadcrumbs ref={ref} {...props} />
})
